export default __webpack_public_path__ + "static/media/shopPreview.0d7c5a5e.png";